<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>æ</u-icon>
      </div>
      <div>
        <div><span>Référentiel</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <h1>{{ $t('pages.Home.title.repository.name')}}</h1>

      <section v-html="staticText"></section>

      <form @submit.prevent="onRepositoryFormSubmit" novalidate>
        <v-select :items="repositories"
                  item-text="name"
                  item-value="id"
                  :label="$t('pages.Home.form.repositories.label.name')"
                  v-model="selected"
                  :error-messages="repositoryErrors"
                  color="valid"
        />
        <v-btn type="submit" color="valid">
          {{ $t('pages.Home.form.repositories.button.name')}}
        </v-btn>
      </form>
    </section>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'selectRepository',
  data () {
    return {
      selected: null,
      staticText: ''
    }
  },
  computed: {
    ...mapGetters('Repositories', [
      'repositories',
      'repositorySelected'
    ]),
    repositoryErrors () {
      const errors = []
      if (!this.$v.selected.$dirty) return errors
      if (!this.$v.selected.required) errors.push('Vous devez sélectionner un référentiel.')
      return errors
    }
  },
  validations: {
    selected: {
      required
    }
  },
  async created () {
    await this.axios({
      method: 'GET',
      url: 'statictexts/gestionnaire_selection_referentiel/'
    }).then(response => {
      this.staticText = response.data.text
    })

    await this.loadAllRepositories()
  },
  methods: {
    ...mapActions('Repositories', [
      'loadAllRepositories',
      'selectRepository'
    ]),
    onRepositoryFormSubmit () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.selectRepository(this.selected)
        this.$router.push({ name: 'repositoryDetail' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
</style>
